import { getBase64Strings } from 'exif-rotate-js';
import { b64toBlob } from './b64toBlob';

export const b64ToBlobWithoutOrientation = async (
  inputString: string
): Promise<Blob> => {
  const imageB64 = await getBase64Strings([b64toBlob(inputString)], {
    maxSize: 3072,
    quality: 1,
    type: 'image/png',
  });
  return b64toBlob(imageB64[0]);
};
